import { Typography, Box, makeStyles, Button, Paper, Container, Grid } from "@material-ui/core";
import React,{useContext} from "react";
import {useHistory} from 'react-router-dom'
import RouteConstants from "../../../common/RouteConstants";
import Helper from "../../../common/Helper";
import { AppDataContext } from "../../../common/AppContext";



const useStyles = makeStyles((theme) => ({
    content: {
        display: 'flex',
        flexGrow: 1,
        padding: theme.spacing(3),
        background: '#f1f1f1',
        flexDirection: 'column',
        justifyContent: 'space-between'

    },
    contentPaper: {
        height: '100%'
    }
}));

const CurriculumFinish = () => {
    const classes = useStyles()
    const history=useHistory()
    const { user } = useContext(AppDataContext);

    const handleBackClick=()=>{
        history.push(RouteConstants.CURRICULUM_DASHBOARD)
    }
    return (
        <main className={classes.content}>
            {/* <Toolbar /> */}
            <Box component="main" >
                <Paper square className={classes.contentPaper}>
                    <Container maxWidth="false">
                        <Grid container spacing={2} mt={0}>

                            {/* //{content.map((ques, i) => { */}

                            {/* <Grid item xs={12}>
                                <Typography variant="body1">
                                    {currentQuestion?.questionTitle ?? ''}
                                </Typography>
                            </Grid> */}
                            <Grid item xs={12} style={{ height: 'calc(100vh - 160px)' }}>
                                <Box component='div' display='flex' justifyContent='center' flexDirection='column' height='100%'>
                                    <Box component='div' display='flex' justifyContent='center'>
                                        <Typography variant="subtitle2" color="textPrimary" style={{ fontSize: '1.2rem' }}>Thank you for completing the curriculum. </Typography>
                                    </Box>
                                    {!Helper.isUserAdmin(user) && Helper.isUserLoggedIn() && <Box component='div' display='flex' justifyContent='center' mt={1}>
                                        <Typography variant="caption" color="textSecondary" style={{ fontSize: '0.8rem' }}>{
                                            (() => {
                                                const [counter, setCounter] = React.useState(3);
                                                const history = useHistory();

                                                React.useEffect(() => {
                                                    if (counter === 0) {
                                                        history.push('/me/lesson-plans');
                                                        return;
                                                    }
                                                    const timer = setTimeout(() => setCounter(counter - 1), 1000);
                                                    return () => clearTimeout(timer);
                                                }, [counter, history]);

                                                return `Redirecting to Curriculum Analysis in ${counter} second${counter !== 1 ? 's' : ''}...`;
                                            })()
                                            }</Typography>
                                    </Box>}
                                   
                                    {Helper.isUserAdmin(user) && <Box component='div' display='flex' justifyContent='center' mt={1}>
                                        <Button variant="contained" color="primary" onClick={handleBackClick}> Back to Dashboard</Button>
                                    </Box>}
                                </Box>
                            </Grid>

                        </Grid>
                    </Container>
                </Paper>
            </Box>
        </main>
    )
}

export default CurriculumFinish